/**
 * Provides reset and delete actions for tag groups.
 */
import React from 'react';
import { observer } from 'mobx-react';
import { Button, Flex } from 'core/components';
import AssetTagInventoryCollection from 'app/stores/assetTags/AssetTagInventoryCollection';
import AssetTagInventoryModel from 'app/stores/assetTags/AssetTagInventoryModel';

interface Props {
  collection: AssetTagInventoryCollection;
  tagId: string;
  group: AssetTagInventoryModel[];
}

function ActionRenderer(props: Props) {
  const { collection, tagId, group } = props;

  return (
    <Flex>
      <Button
        title="Reset"
        icon="reset"
        disabled={!collection.canReset({ tagId })}
        onClick={() => collection.resetGroup(tagId)}
        minimal
        small
      />
      <Button
        title="Remove"
        intent="danger"
        icon="trash"
        onClick={() => collection.removeValues(group)}
        minimal
        small
      />
    </Flex>
  );
}

export default observer(ActionRenderer);
